<p-sidebar class="filter-sidebar" [(visible)]="isVisible" [position]="isMobile ? 'bottom' : 'right'" [blockScroll]="true" [showCloseIcon]="false" (onHide)="close()">
  <ng-template pTemplate="header">
    <div class="header-container">
      <span class="title">Ordenar y filtrar</span>
      <button class="custom-button-clear close" (click)="cancel()"><i class="icon-close"></i></button>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="filters-container">
      @if(!defaultFilters) {
        <div class="active-filters">
          @if (form.controls.category.value) {
            <div class="chip" (click)="resetControls(form.controls.category)">
              <i class="icon-cancel-fill"></i>
              <p class="label">{{ categoryLabels[form.controls.category.value] }}</p>
            </div>
          }
          @if (form.controls.freeShipping.value) {
            <div class="chip" (click)="resetControls(form.controls.freeShipping, false)">
              <i class="icon-cancel-fill"></i>
              <p class="label">Envío gratis</p>
            </div>
          }
          @if (form.controls.max.value && form.controls.min.value) {
            <div class="chip" (click)="resetControls([form.controls.max, form.controls.min])">
              <i class="icon-cancel-fill"></i>
              <p class="label">{{ form.controls.min.value || 0 | currencyFormatter: currency }} - {{ form.controls.max.value || 0 | currencyFormatter: currency }} {{ currency }}</p>
            </div>
          } @else if (form.controls.max.value) {
            <div class="chip" (click)="resetControls(form.controls.max)">
              <i class="icon-cancel-fill"></i>
              <p class="label">Hasta {{ form.controls.max.value || 0 | currencyFormatter: currency }} {{ currency }}</p>
            </div>
          } @else if (form.controls.min.value) {
            <div class="chip" (click)="resetControls(form.controls.min)">
              <i class="icon-cancel-fill"></i>
              <p class="label">Desde {{ form.controls.min.value || 0 | currencyFormatter: currency }}</p>
            </div>
          }
          @if (form.controls.sortBy.value?.field !== 'default') {
            <div class="chip" (click)="resetControls(form.controls.sortBy, sortOptionDefault)">
              <i class="icon-cancel-fill"></i>
              <p class="label">{{ getSortByLabel(form.controls.sortBy.value) }}</p>
            </div>
          }
          @if (form.controls.discounts.value?.length) {
            @for (discount of form.controls.discounts.value; track $index) {
              <div class="chip" (click)="deleteValue(form.controls.discounts, discount)">
                <i class="icon-cancel-fill"></i>
                <p class="label">{{ discount * 100 }}% o más</p>
              </div>
            }
          }
        </div>
      }
      <p-accordion class="accordion-filters">
        <form [formGroup]="form" class="form">
          <p-accordionTab class="accordion-tab" header="Categorías" iconPos="end">
            @for (option of categoriesOptions; track $index) {
              <div class="option">
                <label [for]="'filter-category-' + $index">{{ option.label }}</label>
                <input class="app-radio" type="radio" name="filter-category" [id]="'filter-category-' + $index" [value]="option.value" [formControl]="form.controls.category" />
              </div>
            }
          </p-accordionTab>
          <div class="filter-option">
            <div class="option">
              <label for="free-shipping">Envío gratis</label>
              <input id="free-shipping" class="app-checkbox" type="checkbox" [formControl]="form.controls.freeShipping" />
            </div>
          </div>
          <p-accordionTab class="accordion-tab" header="Ordenar" iconPos="end">
            @for (option of sortOptions; track $index) {
              <div class="option">
                <label [for]="'filter-sort-' + $index">{{ option.label }}</label>
                <input class="app-radio" type="radio" name="filter-sort" [id]="'filter-sort-' + $index" [value]="option.value" [formControl]="form.controls.sortBy" />
              </div>
            }
          </p-accordionTab>
          <p-accordionTab class="accordion-tab" header="Rango de precios" iconPos="end">
            <div class="input-filter-container">
              <label for="min-price">Desde</label>
              <input appNumericInput class="input app-input" id="min-price" type="text" inputmode="decimal" [formControl]="form.controls.min" [currency]="currency" [locale]="locale" placeholder="$" [minimumFractionDigits]="0" [maximumFractionDigits]="2" />
            </div>
            <div class="input-filter-container">
              <label for="max-price">Hasta</label>
              <input appNumericInput class="input app-input" id="max-price" type="text" inputmode="decimal" [formControl]="form.controls.max" [currency]="currency" [locale]="locale" placeholder="$" [minimumFractionDigits]="0" [maximumFractionDigits]="2" />
            </div>
          </p-accordionTab>
          <p-accordionTab class="accordion-tab" header="Descuentos" iconPos="end">
            @for (discount of discountOptions; track $index) {
              <div class="option">
                <label for="discount-{{ discount }}">{{ discount * 100 }}% o más</label>
                <input id="discount-{{ discount }}" class="app-checkbox" type="checkbox" [checked]="form.controls.discounts.value?.includes(discount) ?? false" (change)="onDiscountToggle($event, discount)" />
              </div>
            }
          </p-accordionTab>
        </form>
      </p-accordion>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="filter-sidebar-buttons-container">
      <app-button innerId="btn-p90SUsXC" label="Borrar todos" styleClass="secondary" [disabled]="defaultFilters && !changedFilters" (action)="deleteFiltersAndClose()" />
      <app-button innerId="btn-dm9yZ15L" label="Aplicar filtros" styleClass="primary" [disabled]="!changedFilters || form.invalid" (action)="filter()" />
    </div>
  </ng-template>
</p-sidebar>
